import React from 'react';
import BaseComponent from "../../../../base-component/base-component";

import Classes from 'classnames';
import _ from 'lodash';

export default class ImageComponent extends BaseComponent {

    renderAspectRatio() {
        const { aspectRatio } = this.props.contentState.getEntity(this.props.block.getEntityAt(0)).getData();

        const styles = {paddingTop: '100%'};
        if (aspectRatio) styles.paddingTop = (aspectRatio * 100) + "%";

        return <div className="aspect-ratio-component" style={styles}/>
    }

    render() {
        // omit certain properties from props
        const elementProps = _.omit(this.props, ['preventScroll', 'block', 'className', 'theme', 'blockProps',
            'customStyleMap', 'customStyleFn', 'decorator', 'forceSelection', 'offsetKey', 'selection', 'tree',
            'contentState', 'blockStyleFn', 'isReadOnly']);

        const combinedClassName = Classes("image-plugin-component", this.props.className);
        const { src } = this.props.contentState.getEntity(this.props.block.getEntityAt(0)).getData();

        const styles = _.assign({}, this.props.style, {
            backgroundImage: `url("${src}")`
        })

        return (
            <div className={combinedClassName}
                 draggable="true"
                 {...elementProps}
                 style={styles}>
                {this.renderAspectRatio()}
                {this.props.children}
            </div>
        );
    }
}